import { useQuery } from 'react-query'

import { getFamilyPlanProfiles } from '../api/membership/getFamilyPlanProfiles'

export const useFamilyPlanProfilesQuery = (membershipId?: string) =>
  useQuery(['family-plan-profiles', membershipId], () => getFamilyPlanProfiles(membershipId!), {
    enabled: Boolean(membershipId),
  })
